import {Chip} from "@mui/material";
import {DataTable, DataTableCellProps} from "@variocube/app-ui";
import {useQuery} from "@tanstack/react-query";
import React from "react";
import {Subscription} from "../../api/client";
import {useTenantApi} from "../../api/tenant";
import {useLocalization} from "@smalox/shared";
import {useTenantId} from "../../tenant";
import {queryKeys} from "../../utils/queryKeys";
import {PlanLinkChip} from "../plan/PlanChip";

export function TenantSubscriptions() {
	const {t} = useLocalization();
	const tenantId = useTenantId();
	const {getTenantSubscriptions} = useTenantApi();

	const {data, isLoading, error} = useQuery(
		queryKeys.tenantSubscriptions(tenantId),
		() => getTenantSubscriptions(tenantId),
	);

	const rows = data ?? [];

	const columns = [
		{
			label: t("subscriptions.plan"),
			field: "planName" as const,
			component: ({row}: DataTableCellProps<Subscription>) => (
				<PlanLinkChip plan={{id: row.planId, name: row.planName, features: row.planFeatures ?? []}} />
			),
		},
		{
			label: t("subscriptions.startDate"),
			field: "startDate" as const,
		},
		{
			label: t("subscriptions.endDate"),
			field: "endDate" as const,
			component: ({row}: DataTableCellProps<Subscription>) => (
				row.endDate
					? <>{row.endDate}</>
					: <Chip label={t("subscriptions.status.active")} color="success" size="small" />
			),
		},
	];

	return (
		<DataTable
			columns={columns}
			rows={rows}
			loading={isLoading}
			error={error}
		/>
	);
}
